exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-dialog-content a {\n  color: #448AFF; }\n\nmat-dialog-content span {\n  color: #757575; }\n\nmat-dialog-content mat-icon {\n  color: #BDBDBD; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/decision-dialog/decision-dialog.component.scss
// module id = ../../../../../src/app/components/decision-dialog/decision-dialog.component.scss
// module chunks = main